import { getPhoneCodeByTimezone } from 'timezone-phone-codes';
import ct from 'countries-and-timezones';
import countriesList from 'shared/constants/countries.js';

const getTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

// Splits an E.164 phone number (e.g. "+5117654321") into its country, dial code
// and local number by matching the longest country dial-code prefix. Used to
// pre-fill the phone input from an existing value.
export const parseE164PhoneNumber = (value, countries = countriesList) => {
  if (!value) return { countryCode: '', dialCode: '', number: '' };

  const match = countries
    .filter(country => country.dial_code && value.startsWith(country.dial_code))
    .sort((a, b) => b.dial_code.length - a.dial_code.length)[0];

  if (!match) return { countryCode: '', dialCode: '', number: value };

  return {
    countryCode: match.id,
    dialCode: match.dial_code,
    number: value.slice(match.dial_code.length),
  };
};

export const getActiveDialCode = () => {
  return getPhoneCodeByTimezone(getTimezone()) || '';
};

export const getActiveCountryCode = () => {
  const country = ct.getCountryForTimezone(getTimezone()) || {};
  return country.id || '';
};
